import { RootState } from "@store/index";

export const selectTestSessionList = (state: RootState) => state.testSessionList.data;
export const selectTestSessionListLoading = (state: RootState) => state.testSessionList.loading;
export const selectTestSessionListError = (state: RootState) => state.testSessionList.error;
export const selectTestSessionListLastPage = (state: RootState) => state.testSessionList.lastPage;
export const selectTestSessionListPage = (state: RootState) => state.testSessionList.page;
export const selectTestSessionListFilters = (state: RootState) => state.testSessionList.filters;
export const selectSessionMergeMode = (state: RootState) => state.testSessionList.mergeMode;
export const selectSessionMergeSelection = (state: RootState) =>
  state.testSessionList.mergeSelection;
export const selectSessionMerging = (state: RootState) => state.testSessionList.merging;
export const selectSessionMergeError = (state: RootState) => state.testSessionList.mergeError;
export const selectSessionMergeCompletedCount = (state: RootState) =>
  state.testSessionList.mergeCompletedCount;
export const selectMergedSessionId = (state: RootState) => state.testSessionList.mergedSessionId;
